module.exports = __webpack_public_path__ + "static/media/Milex-Donut-Pessary-Instructions-for-Use.2a923f55.jpg";